module.exports = __webpack_public_path__ + "img/p7-p4-text.2cbc82eb.png";